import React, { useEffect, useState } from "react";
import { CalendarRange } from "lucide-react";
import { Button } from "@/components/ui/button";

export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const back = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d; };
export const PRESETS = {
  7: () => [back(7), back(1)], 28: () => [back(28), back(1)], 90: () => [back(90), back(1)],
  month: () => { const t = new Date(); return [new Date(t.getFullYear(), t.getMonth(), 1), t]; },
  last_month: () => { const t = new Date(); return [new Date(t.getFullYear(), t.getMonth() - 1, 1), new Date(t.getFullYear(), t.getMonth(), 0)]; },
  year: () => { const t = new Date(); return [new Date(t.getFullYear(), 0, 1), t]; },
  180: () => [back(182), back(1)], 365: () => [back(365), back(1)],
};
export const presetRange = (k) => { const [s, e] = PRESETS[k](); return { key: String(k), start: iso(s), end: iso(e) }; };
const LABELS = [["7", "7 days"], ["28", "28 days"], ["90", "90 days"], ["month", "This month"], ["last_month", "Last month"], ["year", "This year"]];

export function RangeBar({ range, setRange, labels = LABELS }) {
  const [from, setFrom] = useState(range.start);
  const [to, setTo] = useState(range.end);
  useEffect(() => { setFrom(range.start); setTo(range.end); }, [range]);
  const today = iso(new Date());
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="ga-range-bar">
      <div className="flex flex-wrap rounded-xl border border-slate-200 bg-white p-1">
        {labels.map(([k, l]) => (
          <button key={k} onClick={() => setRange(presetRange(k))} data-testid={`ga-range-${k}`}
            className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${range.key === k ? "bg-indigo-600 text-white" : "text-slate-600 hover:bg-slate-50"}`}>{l}</button>
        ))}
      </div>
      <div className="flex items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-2 py-1">
        <CalendarRange className="w-4 h-4 text-slate-400" />
        <input type="date" value={from} max={to || today} min="2015-08-14" onChange={(e) => setFrom(e.target.value)} className="text-xs bg-transparent outline-none" data-testid="ga-range-start" />
        <span className="text-xs text-slate-400">to</span>
        <input type="date" value={to} min={from} max={today} onChange={(e) => setTo(e.target.value)} className="text-xs bg-transparent outline-none" data-testid="ga-range-end" />
        <Button size="sm" className="h-7" disabled={!from || !to || from > to || (from === range.start && to === range.end)}
          onClick={() => setRange({ key: "custom", start: from, end: to })} data-testid="ga-range-apply-btn">Apply</Button>
      </div>
    </div>
  );
}
